module.exports = __webpack_public_path__ + "static/media/calendar.a8f545cd.svg";